import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AsyncFunction } from "../../functions/AsyncFunction";

// Stateの初期状態
const initialState = {
    party_id: "",
    member_list: [],
    party_list: [],
    party_detail: null,
    limit_date: "",
    member_list_page: 1,
    member_list_total: 1,
    attendance_1_count: 0,
    attendance_deadline_date: "2000-01-01",
};

export const GetPartyList = function (arg = {}) {
    const params = {
        url: "/api/GetPartyList",
        method: "get",
        params: { ...arg },
        type_name: "パーティー一覧取得",
    };
    return AsyncFunction(params);
};

export const GetAttendanceList = function (arg = {}) {
    const params = {
        url: "/api/GetAttendanceList",
        method: "get",
        params: { ...arg },
        type_name: "参加者一覧取得",
    };
    return AsyncFunction(params);
};

export const DeleteAttendance = function (arg = {}) {
    const params = {
        url: "/api/DeleteAttendance",
        method: "delete",
        params: arg,
        type_name: "参加者削除",
    };
    return AsyncFunction(params);
};

export const PostParty = function (arg = {}) {
    const params = {
        url: "/api/PostParty",
        method: "post",
        params: { ...arg },
        type_name: "懇親会登録",
    };
    return AsyncFunction(params);
};

export const GetPartyDetail = function (arg = {}) {
    const params = {
        url: "/api/GetPartyDetail",
        method: "get",
        params: { ...arg },
        type_name: "GetPartyDetail",
    };
    return AsyncFunction(params);
};

// Sliceを生成する
const slice = createSlice({
    name: "Party",
    initialState,
    reducers: {
        PartySet: (state, action) => {
            const name = action.payload[0];
            const value = action.payload[1];
            state[name] = value;
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                (action) => action.type.match("パーティー一覧取得") && action.type.endsWith("/fulfilled"),
                (state, action) => {
                    const payload = action.payload;
                    state.party_list = payload.party_list;
                }
            )
            .addMatcher(
                (action) => action.type.match("参加者一覧取得") && action.type.endsWith("/fulfilled"),
                (state, action) => {
                    const payload = action.payload;
                    state.member_list = payload.attendance_list;
                    state.member_list_page = payload.page;
                    state.member_list_total = payload.total;
                    state.attendance_1_count = payload.attendance_1_count;
                    state.attendance_deadline_date = payload.attendance_deadline_date;
                }
            )
            .addMatcher(
                (action) => action.type.match("参加者削除") && action.type.endsWith("/fulfilled"),
                (state, action) => {}
            )
            .addMatcher(
                (action) => action.type.match("懇親会登録") && action.type.endsWith("/fulfilled"),
                (state, action) => {
                    const payload = action.payload;
                }
            )
            .addMatcher(
                (action) => action.type.match("GetPartyDetail") && action.type.endsWith("/fulfilled"),
                (state, action) => {
                    const payload = action.payload;
                    state.party_detail = payload.party;
                    state.limit_date = payload.limit_date;
                }
            );
    },
});

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const { PartySet } = slice.actions;
